import PropTypes from 'prop-types';

const ProductPrice = ({ displayPrice = '', formattedPriceRange = '' }) => {
  const price = formattedPriceRange || displayPrice;

  return price;
};

ProductPrice.propTypes = {
  displayPrice: PropTypes.string,
  formattedPriceRange: PropTypes.string,
};

ProductPrice.displayName = 'ProductPrice';

export default ProductPrice;
